import React, { ButtonHTMLAttributes, useState } from 'react';
import { TButtonSize, TColorRole } from '../../types/types';
import IconComponent from '../shared/IconComponents/IconComponent';

interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    label: string;
    role: TColorRole;
    size: TButtonSize;
    stretch?: boolean;
    func?: () => void;
    btnType?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
    hasIcon?: boolean;
    hasLabel?: boolean;
    iconName?: string;
    iconSize?: number;
    
}

export const Button: React.FC<IButtonProps> = ({ hasLabel = true, hasIcon = false, iconName = 'default_icon', iconSize = 1.6, btnType = "button", label, role, func, size, stretch = false }) => {

    
    const [switchClass, setSwitchClass] = useState<boolean>(false);
    
    const onMouseEnter = () => {
        setSwitchClass(true);
    };

    const onMouseLeave = () => {
        setSwitchClass(false);
    };

    return (
        <button type={btnType} onMouseEnter={() => onMouseEnter()} onMouseLeave={() => onMouseLeave()} onClick={func} className={`btn btn-${role} btn-${size} ${stretch ? 'stretch' : ''}`}>
            {
              hasIcon && <IconComponent iconName={iconName} size={iconSize}/>
            }
            {
                hasLabel && <span className={`btn__label ${switchClass ? 'btn__label--anim-up' : 'btn__label--anim-down'}`}>{label}</span>
            }
            
        </button>
    );
};
